import AnchorLinksList from 'components/shared/AnchorLinksList/AnchorLinksList'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './Hero.scss'
import HardwareIcon from './images/hardware.svg'
import heroImage from './images/hero.svg'
import PathIcon from './images/path.svg'
import ProjectIcon from './images/project.svg'
import RpfLogoWithText from './images/rpf-logo-with-text.svg'

export const Hero = ({ loadedSections, t, tReady, gtm = {} }) => {
  const items = t('homepage.hero.items', { returnObjects: true })

  const anchorLinkInfo = [
    {
      id: 'paths',
      image: {
        alt: t('homepage.hero.paths.alt'),
        src: PathIcon,
      },
      title: t('homepage.hero.i-want-to'),
      text: t('homepage.hero.paths.text'),
      href: '#paths',
      gtm: {
        ...gtm,
        label: 'Anchor: Start with path',
      },
    },
    {
      id: 'project',
      image: {
        alt: t('homepage.hero.projects.alt'),
        src: ProjectIcon,
      },
      title: t('homepage.hero.i-want-to'),
      text: t('homepage.hero.projects.text'),
      href: '#projects',
      gtm: {
        ...gtm,
        label: 'Anchor: Start with project',
      },
    },
    {
      id: 'hardware',
      image: {
        alt: t('homepage.hero.hardware.alt'),
        src: HardwareIcon,
      },
      title: t('homepage.hero.i-want-to'),
      text: t('homepage.hero.hardware.text'),
      href: '#hardware',
      gtm: {
        ...gtm,
        label: 'Anchor: Start with Pi Hardware',
      },
    },
  ]

  const loadedAnchorLinkInfo = anchorLinkInfo.filter(
    (item) => loadedSections.indexOf(item.id) !== -1
  )

  return (
    <section className="home-hero__container">
      <div className="home-hero">
        <div className="home-hero__text">
          <p
            className="page-section__title"
            dangerouslySetInnerHTML={{ __html: t('homepage.hero.title') }}
          />
          <ul className="home-hero__list">
            {items &&
              items.map((item, index) => <li key={`item-${index}`}>{item}</li>)}
          </ul>
          <div className="home-hero__rpf-logo-container">
            <p className="home-hero__rpf-logo-text">
              {t('homepage.hero.created-by-rpf')}
            </p>
            <img
              src={RpfLogoWithText}
              alt={t('homepage.hero.rpf-logo-alt')}
              className="home-hero__rpf-logo"
            />
          </div>
        </div>
        <img className="home-hero__image" alt="" src={heroImage} />
      </div>
      <div className="home-hero__anchor-links">
        <div className="home-hero__anchor-links-title">
          <h3>{t('homepage.hero.start')}</h3>
          <span className="home-hero__anchor-links-title-line"></span>
        </div>
        {tReady && <AnchorLinksList anchorLinkInfo={loadedAnchorLinkInfo} />}
      </div>
    </section>
  )
}

Hero.propTypes = {
  loadedSections: PropTypes.arrayOf(PropTypes.string).isRequired,
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool,
  gtm: PropTypes.object,
}

export default withTranslation('translations')(Hero)
